import { PersistedUserNavigationSearchParams } from '@/types/enums/persisted-user-navigation-search-params.enum';

interface BuildPersistedParamsOptions {
  searchParams: Record<string, string | null>;
  cityOverride?: string;
}

export function buildPersistedParamsQueryString({ searchParams, cityOverride }: BuildPersistedParamsOptions): string {
  const params = new URLSearchParams();

  const city = cityOverride || searchParams[PersistedUserNavigationSearchParams.CIDADE];
  if (city) {
    params.append(PersistedUserNavigationSearchParams.CIDADE, city);
  }

  Object.values(PersistedUserNavigationSearchParams).forEach((key) => {
    if (key === PersistedUserNavigationSearchParams.CIDADE) {
      return;
    }
    const value = searchParams[key];
    if (value) {
      params.append(key, value);
    }
  });

  return params.toString();
}

export function appendPersistedParamsToUrl(baseUrl: string, queryString: string): string {
  if (!queryString) {
    return baseUrl;
  }
  const separator = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${separator}${queryString}`;
}

export function buildUrlWithPersistedParams(
  { baseUrl, overrides }: { baseUrl: string; overrides?: Partial<Record<string, string | null>> },
): string {
  const currentParams = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : '',
  );

  const searchParams: Record<string, string | null> = {};
  Object.values(PersistedUserNavigationSearchParams).forEach((key) => {
    const value = currentParams.get(key);
    searchParams[key] = value || null;
  });

  const mergedParams: Record<string, string | null> = { ...searchParams };
  if (overrides) {
    Object.entries(overrides).forEach(([key, value]) => {
      if (value !== undefined) {
        mergedParams[key] = value as string | null;
      }
    });
  }

  const queryString = buildPersistedParamsQueryString({ searchParams: mergedParams });
  return appendPersistedParamsToUrl(baseUrl, queryString);
}
